export enum PaymentType {
  Card = 'C',
  DirectDebit = 'D',
}
